module.exports = __webpack_public_path__ + "static/WindingWorlds6-9eb2b0ba7657038829541a330db9889a.png";